import { DASHBOARD_BASE_URL } from '../services/urls';

export const ECOMMERCE_NA_PRATICA_URL = `${DASHBOARD_BASE_URL}/e-commerce-na-pratica`;

export const DashboardEndpoints = {
  getEcommerceNaPratica: 'getEcommerceNaPratica',
} as const;
